import styled from "styled-components";

export const MonthSettlementHeaderBoxWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 12px;
  row-gap: 10px;
`;

export const MonthSettlementHeaderBox = styled.div<{
  isWide?: boolean;
  isBorder?: boolean;
  isPurple?: boolean;
}>`
  width: 208px;
  height: 103px;
  border-radius: 18px;
  padding: 24px 20px;
  box-sizing: border-box;
  background: ${(p) => (p.isPurple ? "#7F25FB" : "#ecf0f3")};
  color: ${(p) => (p.isPurple ? "#fff" : "#121212")};
  font-family: Pretendard;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: ${(p) => (p.isBorder ? "3px solid #7F25FB" : "none")};

  > .name {
    font-size: 16px;
    display: flex;
    gap: 6px;
    align-items: center;
    position: relative;
    height: 19px;
    line-height: 19px;

    > img {
      width: 19px;
      height: 19px;
      cursor: pointer;
    }
  }

  > .value {
    font-size: 22px;
    text-align: right;
  }
`;

export const MonthSettlementSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-bottom: 50px;
`;
